const ScrollService = {
    scroll: (offset: number) => {
        if (typeof window !== 'undefined') {
            window.scrollTo({
                top: offset,
                behavior: 'smooth',
            });
        }
    },
};

export { ScrollService };
